<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-skate-percentages-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 660}
    <div id="g-skate-percentages-xs" class="g-artboard" style="">
      <div style="padding: 0 0 187.8788% 0;"></div>
      <div
        id="g-skate-percentages-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/skate-percentages-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:8.3535%;width:29px;"
      >
        <p class="g-pstyle0">0</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:16.2491%;width:34px;"
      >
        <p class="g-pstyle0">10</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:33.0861%;width:35px;"
      >
        <p class="g-pstyle0">30</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:41.5382%;width:36px;"
      >
        <p class="g-pstyle0">40</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:50.1139%;width:36px;"
      >
        <p class="g-pstyle0">50</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:67.3853%;width:35px;"
      >
        <p class="g-pstyle0">70</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:90.5998%;width:51px;"
      >
        <p class="g-pstyle0">100%</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:24.4904%;width:36px;"
      >
        <p class="g-pstyle0">20</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:58.6642%;width:36px;"
      >
        <p class="g-pstyle0">60</p>
      </div>
      <div
        id="g-ai0-10"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:75.7537%;width:36px;"
      >
        <p class="g-pstyle0">80</p>
      </div>
      <div
        id="g-ai0-11"
        class="g-text g-aiAbs g-aiPointText"
        style="top:2.4997%;margin-top:-7.5px;left:84.3315%;width:36px;"
      >
        <p class="g-pstyle0">90</p>
      </div>
      <div
        id="g-ai0-12"
        class="g-text g-aiAbs g-aiPointText"
        style="top:9.5965%;margin-top:-7.5px;left:1.221%;width:48px;"
      >
        <p class="g-pstyle0">1900</p>
      </div>
      <div
        id="g-ai0-13"
        class="g-text g-aiAbs g-aiPointText"
        style="top:16.5527%;margin-top:-9.6px;left:19.4798%;width:147px;"
      >
        <p class="g-pstyle1">Figures percentage</p>
      </div>
      <div
        id="g-ai0-14"
        class="g-text g-aiAbs g-aiPointText"
        style="top:18.0051%;margin-top:-18.6px;left:70.0142%;width:93px;"
      >
        <p class="g-pstyle2">Free Skate</p>
        <p class="g-pstyle2">percentage</p>
      </div>
      <div
        id="g-ai0-15"
        class="g-text g-aiAbs g-aiPointText"
        style="top:17.9836%;margin-top:-7.5px;left:1.6531%;width:45px;"
      >
        <p class="g-pstyle0">1910</p>
      </div>
      <div
        id="g-ai0-16"
        class="g-text g-aiAbs g-aiPointText"
        style="top:26.6932%;margin-top:-7.5px;left:1.3428%;width:47px;"
      >
        <p class="g-pstyle0">1920</p>
      </div>
      <div
        id="g-ai0-17"
        class="g-text g-aiAbs g-aiPointText"
        style="top:35.2416%;margin-top:-7.5px;left:1.3787%;width:47px;"
      >
        <p class="g-pstyle0">1930</p>
      </div>
      <div
        id="g-ai0-18"
        class="g-text g-aiAbs g-aiPointText"
        style="top:43.79%;margin-top:-7.5px;left:1.2811%;width:47px;"
      >
        <p class="g-pstyle0">1940</p>
      </div>
      <div
        id="g-ai0-19"
        class="g-text g-aiAbs g-aiPointText"
        style="top:52.4997%;margin-top:-7.5px;left:1.3%;width:47px;"
      >
        <p class="g-pstyle0">1950</p>
      </div>
      <div
        id="g-ai0-20"
        class="g-text g-aiAbs g-aiPointText"
        style="top:61.1421%;margin-top:-9.1px;left:14.8507%;width:93px;"
      >
        <p class="g-pstyle3">Winter 1960 - First</p>
      </div>
      <div
        id="g-ai0-21"
        class="g-text g-aiAbs g-aiPointText"
        style="top:61.1421%;margin-top:-9.1px;left:36.7825%;width:62px;"
      >
        <p class="g-pstyle3"></p>
      </div>
      <div
        id="g-ai0-22"
        class="g-text g-aiAbs g-aiPointText"
        style="top:61.0481%;margin-top:-7.5px;left:1.2948%;width:47px;"
      >
        <p class="g-pstyle0">1960</p>
      </div>
      <div
        id="g-ai0-23"
        class="g-text g-aiAbs g-aiPointText"
        style="top:63.884%;margin-top:-9.1px;left:9.1579%;width:155px;"
      >
        <p class="g-pstyle3">Olympics on TV in USA</p>
      </div>
      <div
        id="g-ai0-24"
        class="g-text g-aiAbs g-aiPointText"
        style="top:69.4352%;margin-top:-7.5px;left:1.4748%;width:46px;"
      >
        <p class="g-pstyle0">1970</p>
      </div>
      <div
        id="g-ai0-25"
        class="g-text g-aiAbs g-aiPointText"
        style="top:78.1448%;margin-top:-7.5px;left:1.2743%;width:47px;"
      >
        <p class="g-pstyle0">1980</p>
      </div>
      <div
        id="g-ai0-26"
        class="g-text g-aiAbs g-aiPointText"
        style="top:86.8545%;margin-top:-7.5px;left:1.288%;width:47px;"
      >
        <p class="g-pstyle0">1990</p>
      </div>
      <div
        id="g-ai0-27"
        class="g-text g-aiAbs g-aiPointText"
        style="top:87.3591%;margin-top:-9.6px;left:28.5112%;width:139px;"
      >
        <p class="g-pstyle2">Figures eliminated</p>
      </div>
      <div
        id="g-ai0-28"
        class="g-text g-aiAbs g-aiPointText"
        style="top:91.8761%;margin-top:-18.6px;left:73.0825%;width:76px;"
      >
        <p class="g-pstyle2">Short</p>
        <p class="g-pstyle2">program</p>
      </div>
      <div
        id="g-ai0-29"
        class="g-text g-aiAbs g-aiPointText"
        style="top:95.5642%;margin-top:-7.5px;left:0.5478%;width:50px;"
      >
        <p class="g-pstyle0">2000</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660}
    <div id="g-skate-percentages-md" class="g-artboard" style="">
      <div style="padding: 0 0 51.9697% 0;"></div>
      <div
        id="g-skate-percentages-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/skate-percentages-md.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-text g-aiAbs g-aiPointText"
        style="top:3.0708%;margin-top:-7.5px;left:0.2813%;width:51px;"
      >
        <p class="g-pstyle0">100%</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-text g-aiAbs g-aiPointText"
        style="top:11.8171%;margin-top:-7.5px;left:0.2813%;width:36px;"
      >
        <p class="g-pstyle0">90</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-text g-aiAbs g-aiPointText"
        style="top:16.9575%;margin-top:-10.2px;left:12.1237%;width:171px;"
      >
        <p class="g-pstyle1">Free Skate percentage</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-text g-aiAbs g-aiPointText"
        style="top:16.9575%;margin-top:-10.2px;left:78.3055%;width:120px;"
      >
        <p class="g-pstyle1">Short program</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-text g-aiAbs g-aiPointText"
        style="top:20.5635%;margin-top:-7.5px;left:0.2813%;width:36px;"
      >
        <p class="g-pstyle0">80</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-text g-aiAbs g-aiPointText"
        style="top:29.3098%;margin-top:-7.5px;left:0.2813%;width:35px;"
      >
        <p class="g-pstyle0">70</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-text g-aiAbs g-aiPointText"
        style="top:38.0562%;margin-top:-7.5px;left:0.2813%;width:36px;"
      >
        <p class="g-pstyle0">60</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-text g-aiAbs g-aiPointText"
        style="top:46.8025%;margin-top:-7.5px;left:0.2813%;width:36px;"
      >
        <p class="g-pstyle0">50</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-text g-aiAbs g-aiPointText"
        style="top:55.8404%;margin-top:-7.5px;left:0.2813%;width:36px;"
      >
        <p class="g-pstyle0">40</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-text g-aiAbs g-aiPointText"
        style="top:59.8146%;margin-top:-10.2px;left:50.8067%;width:103px;"
      >
        <p class="g-pstyle2">Winter 1960 - First</p>
      </div>
      <div
        id="g-ai1-11"
        class="g-text g-aiAbs g-aiPointText"
        style="top:59.8146%;margin-top:-10.2px;left:62.4973%;width:68px;"
      >
        <p class="g-pstyle2"></p>
      </div>
      <div
        id="g-ai1-12"
        class="g-text g-aiAbs g-aiPointText"
        style="top:60.6892%;margin-top:-10.2px;left:78.0025%;width:146px;"
      >
        <p class="g-pstyle1">Figures eliminated</p>
      </div>
      <div
        id="g-ai1-13"
        class="g-text g-aiAbs g-aiPointText"
        style="top:63.0216%;margin-top:-10.2px;left:12.8813%;width:156px;"
      >
        <p class="g-pstyle3">Figures percentage</p>
      </div>
      <div
        id="g-ai1-14"
        class="g-text g-aiAbs g-aiPointText"
        style="top:64.5868%;margin-top:-7.5px;left:0.2813%;width:36px;"
      >
        <p class="g-pstyle0">30</p>
      </div>
      <div
        id="g-ai1-15"
        class="g-text g-aiAbs g-aiPointText"
        style="top:65.0624%;margin-top:-10.2px;left:47.7723%;width:174px;"
      >
        <p class="g-pstyle2">Olympics on TV in USA</p>
      </div>
      <div
        id="g-ai1-16"
        class="g-text g-aiAbs g-aiPointText"
        style="top:73.3332%;margin-top:-7.5px;left:0.2813%;width:36px;"
      >
        <p class="g-pstyle0">20</p>
      </div>
      <div
        id="g-ai1-17"
        class="g-text g-aiAbs g-aiPointText"
        style="top:82.0795%;margin-top:-7.5px;left:0.2813%;width:34px;"
      >
        <p class="g-pstyle0">10</p>
      </div>
      <div
        id="g-ai1-18"
        class="g-text g-aiAbs g-aiPointText"
        style="top:90.8259%;margin-top:-7.5px;left:0.2813%;width:29px;"
      >
        <p class="g-pstyle0">0</p>
      </div>
      <div
        id="g-ai1-19"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:7.4791%;width:48px;"
      >
        <p class="g-pstyle0">1900</p>
      </div>
      <div
        id="g-ai1-20"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:16.0736%;width:45px;"
      >
        <p class="g-pstyle0">1910</p>
      </div>
      <div
        id="g-ai1-21"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:24.6684%;width:47px;"
      >
        <p class="g-pstyle0">1920</p>
      </div>
      <div
        id="g-ai1-22"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:33.2653%;width:47px;"
      >
        <p class="g-pstyle0">1930</p>
      </div>
      <div
        id="g-ai1-23"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:41.8601%;width:47px;"
      >
        <p class="g-pstyle0">1940</p>
      </div>
      <div
        id="g-ai1-24"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:50.4569%;width:47px;"
      >
        <p class="g-pstyle0">1950</p>
      </div>
      <div
        id="g-ai1-25"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:59.0516%;width:47px;"
      >
        <p class="g-pstyle0">1960</p>
      </div>
      <div
        id="g-ai1-26"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:67.6486%;width:46px;"
      >
        <p class="g-pstyle0">1970</p>
      </div>
      <div
        id="g-ai1-27"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:76.2432%;width:47px;"
      >
        <p class="g-pstyle0">1980</p>
      </div>
      <div
        id="g-ai1-28"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:84.8402%;width:47px;"
      >
        <p class="g-pstyle0">1990</p>
      </div>
      <div
        id="g-ai1-29"
        class="g-text g-aiAbs g-aiPointText"
        style="top:97.2399%;margin-top:-7.5px;left:93.4348%;width:50px;"
      >
        <p class="g-pstyle0">2000</p>
      </div>
    </div>
  {/if}
</div>

<!-- End ai2html - 2026-02-19 15:49 -->

<!-- Generated by ai2html v0.100.0 - 2026-02-19 15:49 -->
<!-- ai file: skate-percentages.ai -->
<style lang="scss">
  #g-skate-percentages-box,
  #g-skate-percentages-box .g-artboard {
    margin: 0 auto;
  }
  #g-skate-percentages-box p {
    margin: 0;
  }
  #g-skate-percentages-box .g-aiAbs {
    position: absolute;
  }
  #g-skate-percentages-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-skate-percentages-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-skate-percentages-xs {
    position: relative;
    overflow: hidden;
  }
  #g-skate-percentages-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(51, 51, 51);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-skate-percentages-xs .g-pstyle0 {
    height: 14px;
  }
  #g-skate-percentages-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    color: rgb(249, 249, 249);
  }
  #g-skate-percentages-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    color: rgb(0, 0, 0);
  }
  #g-skate-percentages-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(252, 252, 252);
  }
  #g-skate-percentages-md {
    position: relative;
    overflow: hidden;
  }
  #g-skate-percentages-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(51, 51, 51);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-skate-percentages-md .g-pstyle0 {
    height: 14px;
  }
  #g-skate-percentages-md .g-pstyle1 {
    font-weight: 400;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
    color: rgb(0, 0, 0);
  }
  #g-skate-percentages-md .g-pstyle2 {
    font-weight: 400;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
    color: rgb(252, 252, 252);
  }
  #g-skate-percentages-md .g-pstyle3 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
    color: rgb(249, 249, 249);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
